import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7471633c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "EditProductStatusLog SideBar_False" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "EditProductStatusLog_Title" }, "商品ステータス 変更履歴", -1))
const _hoisted_3 = { class: "EditProductStatusLog_TableContainer" }
const _hoisted_4 = { class: "EditProductStatusLog_Table" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "EditProductStatusLog_Table_SyosiInfo EditProductStatusLog_Table_Sticky_TH1 EditProductStatusLog_Table_Wide" }, [
      /*#__PURE__*/_createTextVNode(" 書誌CD"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("ISBN ")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "EditProductStatusLog_Table_Sticky_TH2 EditProductStatusLog_Table_Wide" }, " 書誌名 "),
    /*#__PURE__*/_createElementVNode("th", { class: "EditProductStatusLog_Table_Bikou EditProductStatusLog_Table_Wide" }, [
      /*#__PURE__*/_createTextVNode(" 商品備考"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("(表示期限) ")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "EditProductStatusLog_Table_Bikou EditProductStatusLog_Table_Wide" }, [
      /*#__PURE__*/_createTextVNode(" VAN強制ST"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("(表示期限) ")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "EditProductStatusLog_Table_Narrow" }, "良品"),
    /*#__PURE__*/_createElementVNode("th", { class: "EditProductStatusLog_Table_Narrow" }, "返品"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("本体"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("価格")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, "ISBN13桁"),
    /*#__PURE__*/_createElementVNode("th", { class: "EditProductStatusLog_Table_Narrow" }, "取置"),
    /*#__PURE__*/_createElementVNode("th", null, "当日受注入力数"),
    /*#__PURE__*/_createElementVNode("th", null, "保留合計"),
    /*#__PURE__*/_createElementVNode("th", null, "シリーズ名"),
    /*#__PURE__*/_createElementVNode("th", null, "カテゴリ"),
    /*#__PURE__*/_createElementVNode("th", { class: "EditProductStatusLog_Table_Middle" }, "現在在庫ST"),
    /*#__PURE__*/_createElementVNode("th", { class: "EditProductStatusLog_Table_Middle" }, "発売日"),
    /*#__PURE__*/_createElementVNode("th", { class: "EditProductStatusLog_Table_Narrow" }, "スリップ"),
    /*#__PURE__*/_createElementVNode("th", { class: "EditProductStatusLog_Table_Narrow" }, "カバー"),
    /*#__PURE__*/_createElementVNode("th", { class: "EditProductStatusLog_Table_Narrow" }, "帯"),
    /*#__PURE__*/_createElementVNode("th", { class: "EditProductStatusLog_Table_Narrow" }, "ケース"),
    /*#__PURE__*/_createElementVNode("th", null, "改装出来予定日"),
    /*#__PURE__*/_createElementVNode("th", { class: "EditProductStatusLog_Table_Narrow" }, "改装出来予定数"),
    /*#__PURE__*/_createElementVNode("th", null, "重版出来予定日"),
    /*#__PURE__*/_createElementVNode("th", { class: "EditProductStatusLog_Table_Narrow" }, "重版出来予定数"),
    /*#__PURE__*/_createElementVNode("th", { class: "EditProductStatusLog_Table_Narrow" }, "最新刷数"),
    /*#__PURE__*/_createElementVNode("th", { class: "EditProductStatusLog_Table_Narrow" }, "断裁"),
    /*#__PURE__*/_createElementVNode("th", null, "著者")
  ])
], -1))
const _hoisted_6 = { class: "EditProductStatusLog_Table_SyosiInfo EditProductStatusLog_Table_Sticky_TD1 Text_Left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "EditProductStatusLog_Table_SyosiInfo EditProductStatusLog_Table_Sticky_TD2 Text_Left" }
const _hoisted_9 = { class: "EditProductStatusLog_Table_Bikou" }
const _hoisted_10 = { class: "EditProductStatusLog_Table_Flex" }
const _hoisted_11 = { class: "EditProductStatusLog_Table_Bikou_Text" }
const _hoisted_12 = { class: "EditProductStatusLog_TextHL" }
const _hoisted_13 = {
  key: 0,
  class: "EditProductStatusLog_TextHL"
}
const _hoisted_14 = {
  key: 1,
  class: "EditProductStatusLog_TextHL"
}
const _hoisted_15 = { class: "EditProductStatusLog_Table_Bikou" }
const _hoisted_16 = { class: "EditProductStatusLog_Table_Flex" }
const _hoisted_17 = { class: "EditProductStatusLog_Table_Bikou_Text" }
const _hoisted_18 = { class: "EditProductStatusLog_TextHL" }
const _hoisted_19 = {
  key: 0,
  class: "EditProductStatusLog_TextHL"
}
const _hoisted_20 = {
  key: 1,
  class: "EditProductStatusLog_TextHL"
}
const _hoisted_21 = { class: "Text_Red" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 0,
  class: "ResultMessageNull"
}

import axios from "axios";
import { Notyf } from "notyf";
import { ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { ZaikoData } from "./EditProductStatus.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditProductStatusLog',
  emits: ["toggleGlobalHeader"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const route = useRoute();
const notyf = new Notyf();
const emit = __emit;

emit("toggleGlobalHeader");

// データ取得
const search_result = ref([] as ZaikoData[]);
const getData = async () => {
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/syosi/display-from-dashborad?uuid=${route.query.uuid}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    search_result.value = res.data.syosiList;
  } catch (error) {
    console.log(error);
    notyf.error("データの取得に失敗しました");
  }
};
getData();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(search_result.value, (result, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_6, [
                _createTextVNode(_toDisplayString(result.syosiCd), 1),
                _hoisted_7,
                _createTextVNode(_toDisplayString(result.isbn), 1)
              ]),
              _createElementVNode("td", _hoisted_8, _toDisplayString(result.title), 1),
              _createElementVNode("td", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("p", _hoisted_12, _toDisplayString(result.itemRemarks), 1),
                    (
                      result.itemRemarks !== null &&
                      result.remarksDeadline === '9999-12-31'
                    )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_13, " (無期限) "))
                      : (result.remarksDeadline)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, " (" + _toDisplayString(result.remarksDeadline) + ") ", 1))
                        : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("td", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(store).getters["constant/getTargetVanStatus"](
                        result.updateStatus
                      )), 1),
                    (
                      result.updateStatus !== null &&
                      result.toUpdateStatusDate === '9999-12-31'
                    )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, " (無期限) "))
                      : (
                      result.fromUpdateStatusDate && result.toUpdateStatusDate
                    )
                        ? (_openBlock(), _createElementBlock("p", _hoisted_20, " (" + _toDisplayString(result.fromUpdateStatusDate) + "~" + _toDisplayString(result.toUpdateStatusDate) + ") ", 1))
                        : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("td", null, _toDisplayString(result.items), 1),
              _createElementVNode("td", null, _toDisplayString(result.returnItems), 1),
              _createElementVNode("td", null, _toDisplayString(result.hontaiPrice), 1),
              _createElementVNode("td", null, _toDisplayString(result.janCd), 1),
              _createElementVNode("td", null, _toDisplayString(result.torioki), 1),
              _createElementVNode("td", null, _toDisplayString(result.inputSum), 1),
              _createElementVNode("td", null, _toDisplayString(result.holdSum), 1),
              _createElementVNode("td", null, _toDisplayString(result.series), 1),
              _createElementVNode("td", null, _toDisplayString(result.category), 1),
              _createElementVNode("td", null, _toDisplayString(result.zsName), 1),
              _createElementVNode("td", null, _toDisplayString(result.releaseDate), 1),
              _createElementVNode("td", null, _toDisplayString(result.slip), 1),
              _createElementVNode("td", null, _toDisplayString(result.cover), 1),
              _createElementVNode("td", null, _toDisplayString(result.obi), 1),
              _createElementVNode("td", null, _toDisplayString(result.bookCase), 1),
              _createElementVNode("td", null, _toDisplayString(result.kaisoSchduledDate), 1),
              _createElementVNode("td", null, _toDisplayString(result.kaisoSchduledQuantity), 1),
              _createElementVNode("td", null, _toDisplayString(result.juhanSchduledDate), 1),
              _createElementVNode("td", null, _toDisplayString(result.juhanSchduledQuantity), 1),
              _createElementVNode("td", null, _toDisplayString(result.latestPrints), 1),
              _createElementVNode("td", _hoisted_21, [
                (result.cutting === true)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, "断"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, _toDisplayString(result.author), 1)
            ]))
          }), 128))
        ])
      ]),
      (!search_result.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, " ※検索結果はありません "))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})